import * as React from 'react';
import { memo } from 'react';

const SvgFunnel = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 19 19", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4.814 9.185h9M2.002 5.81h14.625M7.627 12.56h3.375", stroke: "currentColor", strokeWidth: 1.125, strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgFunnel);

export { Memo as default };
